<form [formGroup]="form">
  <div class="chip-field">
    <mat-chip-list #tagsChips>
      <mat-chip *ngFor="let tag of item?.tags" [selectable]="!readOnly" [removable]="false" color="primary">
        {{tag}}
        <mat-icon matChipRemove (click)="removeTag(tag)" *ngIf="!readOnly">cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>

    <mat-form-field matTooltip="Select a Tag from the list" class="crud-item-input-wide">
      <mat-label i18n="@@type.Asset.tags">Tags</mat-label>
      <input matInput [matAutocomplete]="tagsAutocomplete" [matChipInputFor]="tagsChips" formControlName="tags"
        (keydown.enter)="selectedTagEnter()" id="tags" #tags placeholder="Tags" [(ngModel)]="tagInputField"
        (click)="tagsAutocompleteTrigger.openPanel()">
      <mat-autocomplete id="tagsAutocomplete" #tagsAutocomplete (optionSelected)="selectedTagClick($event)">
        <mat-option [value]="tagInputField" *ngIf="tagInputField && isNewTag(tagInputField)">
          {{tagInputField}} (new)
        </mat-option>
        <mat-option *ngFor="let tag of tagsSelectionList | async" [value]="tag">
          {{tag}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</form>